// Material UI
import { makeStyles } from '@material-ui/core';
import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  customMoreVertButton: { marginLeft: 'auto' },
  paper: {
    position: 'relative',
    '@media print': {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      height: '100vh',
      width: '100%',
      maxWidth: '67.5rem',
      padding: '1rem',
      overflowY: 'hidden',
      '@media print': {
        display: 'none',
      },
    },
  },
  title: {
    fontFamily: 'PP Object Sans',
    fontWeight: 700,
    lineHeight: '2rem',
    color: neutral[100],
    padding: 0,
  },
  header: {
    paddingBottom: '0.5rem',
    paddingTop: 0,
  },
  headerRoot: {
    border: 'none',
  },
}));
